import DataTable from "react-data-table-component";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { ECommerce, ProductList, ProductListText, ProductListTitle } from "../../../Constant";
import { PRODUCT_DATA_TABLE, PRODUCT_DATA_TABLE_COLUMN } from "../../../Data/Ecommerce";

const ProductListContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={ProductList} parent={ECommerce} title={ProductList} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ProductListTitle} spanText={ProductListText} />
              <CardBody>
                <div className="table-responsive product-table">
                  <DataTable data={PRODUCT_DATA_TABLE} columns={PRODUCT_DATA_TABLE_COLUMN} highlightOnHover responsive className="display dataTable no-footer" noHeader pagination paginationServer />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProductListContainer;
